
import React from 'react';

interface ProgressDotProps {
  active: boolean;
  progress: number;
}

export const ProgressDot = ({ active, progress }: ProgressDotProps) => {
  let dotColor = 'bg-gray-200'; // Default inactive color
  
  if (active) {
    if (progress < 40) {
      dotColor = 'bg-[#ea384c]';
    } else if (progress < 70) {
      dotColor = 'bg-[#FFD43B]';
    } else {
      dotColor = 'bg-purple-700';
    }
  }
  
  return <div className={`h-2 w-2 rounded-full ${dotColor}`} />;
};
